// Animate On Scroll Options
// https://github.com/michalsnik/aos
import AOS from 'aos';

AOS.init({
    duration: 400,
    offset: -80,
    once: false,
});